import React, { useEffect } from "react";
import { Select, InputNumber } from "antd";
import { connect } from "react-redux";
import { SearchOutlined } from "@ant-design/icons";
import { CircleCheck, Sparkles } from "lucide-react";
import TextArea from "antd/es/input/TextArea";
import FormItem from "components/fields/FormItem";
import { getEmployeeList } from "../../../../../redux/employee/employeeState";

const { Option } = Select;

const AwardeeSelector = ({
  employees,
  requesting,
  pagination,
  doSearch,
  category,
  points,
}) => {

  useEffect(() => {
    doSearch({ paginate: pagination?.per_page || 10 });
  }, [doSearch, pagination?.per_page]);

  return (
    <div className="space-y-4">
      <FormItem
        label="Select Team Member"
        name="erw_employee_id"
        rules={[{ required: true, message: "Please select a team member" }]}
      >
        <Select
          showSearch
          loading={requesting}
          placeholder="Choose a team member to reward"
          optionFilterProp="children"
          optionLabelProp="label"
          suffixIcon={<SearchOutlined />}
        >
          {employees?.map((emp) => (
            <Option
              key={emp.emp_id}
              value={emp.emp_id}
              label={emp.employee_name}
            >
              <div className="flex flex-col px-2">
                <div className="flex items-center gap-2">
                  <div className="w-4 flex justify-center">
                    <CircleCheck size={16} className="opacity-0" />
                  </div>

                  <div className="flex flex-col">
                    <span>{emp.employee_name}</span>
                    <span className="text-[11px] text-gray-500">
                      {emp.emp_title} • {emp.department_name}
                    </span>
                  </div>
                </div>
              </div>
            </Option>
          ))}
        </Select>
      </FormItem>

    <FormItem
      label="Gift credits amount"
      name="erw_points_awarded"
      initialValue={points}
      rules={[
        { required: true, message: "Please provide a credit amount" },
      ]}
    >
      <InputNumber min={1} style={{ width: "100%" }} />
    </FormItem>

      <p className="text-[11px] text-gray-600 -mt-2">
        Suggested: {points} credits for this category
      </p>

      <FormItem
        label="Reason for award"
        name="erw_reason"
        rules={[{ required: true, message: "Please provide a reason" }]}
      >
        <TextArea
          maxLength={255}
          placeholder="Describe the specific achievement or contribution..."
        />
      </FormItem>

      <div className={`flex card-theme ${category} gap-2 rounded-xl p-4`}>
        <div className="p-2">
          <Sparkles className="h-5 w-5 card-text" />
        </div>
        <div className="card-text">
          <p className="text-[13px]">Award Tips</p>
          <p className="text-[12px] font-medium">
            Be specific about the achievement. Include measurable results,
            dates, or project names.
          </p>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  employees: state.employee.employeeList?.items,
  pagination: state.employee.employeeList?.pagination,
  requesting: state.employee.employeeList?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getEmployeeList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AwardeeSelector);